import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Breadcrumbs, breadcrumbJsonLd } from "@/components/Breadcrumbs";
import fachadaAsset from "../assets/casa/fachada.webp.asset.json";
import salonAsset from "../assets/casa/salon.webp.asset.json";
import hab1Asset from "../assets/casa/habitacion-1.webp.asset.json";
import hab2Asset from "../assets/casa/habitacion-2.webp.asset.json";
import comedorAsset from "../assets/casa/comedor.webp.asset.json";
import cocinaAsset from "../assets/casa/cocina.webp.asset.json";
import banoAsset from "../assets/casa/bano.webp.asset.json";

export const Route = createFileRoute("/galeria")({
  head: () => ({
    meta: [
      { title: "Galería · El Pajar de Benito" },
      { name: "description", content: "Fotografías de la casa, las habitaciones y el entorno de El Pajar de Benito en El Ordial." },
      { property: "og:title", content: "Galería · El Pajar de Benito" },
      { property: "og:description", content: "Recorre en imágenes la fachada de piedra, el salón con chimenea, la cocina, las 6 habitaciones y los baños de El Pajar de Benito." },
      { property: "og:url", content: "/galeria" },
    ],
    links: [{ rel: "canonical", href: "https://elpajardebenito.es/galeria" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbJsonLd([
            { label: "Inicio", to: "/" },
            { label: "Galería", to: "/galeria" },
          ]),
        ),
      },
    ],
  }),
  component: Galeria,
});

const fotos = [
  { src: fachadaAsset.url, alt: "Fachada de piedra de El Pajar de Benito" },
  { src: salonAsset.url, alt: "Salón principal con suelo de barro y vigas" },
  { src: comedorAsset.url, alt: "Comedor con chimenea de piedra" },
  { src: cocinaAsset.url, alt: "Cocina equipada con horno de leña" },
  { src: hab1Asset.url, alt: "Habitación doble con paredes en tono ocre" },
  { src: hab2Asset.url, alt: "Habitación doble con muro de piedra vista" },
  { src: banoAsset.url, alt: "Baño privado con ducha de obra" },
];

function Galeria() {
  const [active, setActive] = useState<number | null>(null);
  return (
    <>
      <Breadcrumbs items={[{ label: "Inicio", to: "/" }, { label: "Galería" }]} />
      <section className="mx-auto max-w-4xl px-4 pt-20 pb-12 text-center md:px-6 md:pt-28">
        <p className="text-xs uppercase tracking-[0.28em] text-accent">Galería</p>
        <h1 className="mt-4 font-serif text-4xl text-foreground md:text-5xl">La casa, en imágenes</h1>
      </section>
      <section className="mx-auto max-w-6xl px-4 pb-24 md:px-6">
        <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4">
          {fotos.map((f, i) => (
            <button key={i} onClick={() => setActive(i)} className="block w-full overflow-hidden rounded-sm">
              <img src={f.src} alt={f.alt} loading="lazy" className="w-full transition-transform duration-500 hover:scale-[1.02]" />
            </button>
          ))}
        </div>
      </section>
      {active !== null && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 p-4" onClick={() => setActive(null)} role="dialog" aria-modal="true">
          <img src={fotos[active].src} alt={fotos[active].alt} className="max-h-[90vh] max-w-[95vw] object-contain" />
          <button onClick={() => setActive(null)} className="absolute top-5 right-5 text-2xl text-white" aria-label="Cerrar">×</button>
        </div>
      )}
    </>
  );
}